import React from 'react'

import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableHeadText, TableColText, TableColLabelValue } from '../../../../../components/pdf/TableHelpers'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import Bar from '../../../../../components/pdf/Bar'
import View from '../../../../../components/pdf/View'
import {
  toCurrency,
  findReplyByQuestionName,
  findReplyByQuestionId,
  filterRepliesByParentReference,
  currencyToNumber,
  getFieldValue,
  mountAssetsValues
} from '../../_helpers/pdfHelpers'
import { useMemo } from 'react'
import { useAssetsFieldValues } from '../../_load/AssetsFieldValuesLoader'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import { useParentServiceOrder } from '../../_load/ParentServiceOrderLoader'

const Budget = ({ type }) => {
  const isVivo = type === 'VIVO'
  const mainServiceOrder = useServiceOrder()
  const parentServiceOrder = useParentServiceOrder()

  const serviceOrder = parentServiceOrder || mainServiceOrder
  const assetsFieldValues = useAssetsFieldValues()

  const assetsData = useMemo(() => {
    const mainAssetReply = findReplyByQuestionName(serviceOrder.replies, 'Equipamentos trocados')
    const assets = filterRepliesByParentReference(serviceOrder.replies, mainAssetReply.question.reference)
    const assetsValues = mountAssetsValues(assets)
    const assetsData = []
    assetsValues.forEach(asset => {
      const id = asset.id
      const assetName = asset['Selecione o equipamento trocado']
      const qtd = asset['Quantidade']

      const fields = assetsFieldValues.find(assetsFieldValues => assetsFieldValues.id === id)
      if (!fields || !fields.fieldValues) {
        return
      }

      const assetValue = getFieldValue(fields, 'Valor do Equipamento (R$)')
      const workHourValue = getFieldValue(fields, 'Valor da Mão de Obra (R$)')
      const fieldInternalCode = getFieldValue(fields, 'Código do Equipamento')
      const internalCode = fieldInternalCode ? fieldInternalCode.value : ''
      assetsData.push({
        internalCode,
        codEquip: internalCode,
        description: assetName,
        qtd: Number(qtd),
        unitPrice: currencyToNumber(assetValue ? assetValue.value : 0),
        workHour: currencyToNumber(workHourValue ? workHourValue.value : 0)
      })
    })

    return assetsData
  }, [serviceOrder, assetsFieldValues])

  const sumTotalAssets = () => {
    const total = {
      totalQtd: 0,
      totalUnitPrice: 0,
      sumWorkHour: 0,
      totalWorkHour: 0,
      total: 0
    }
    assetsData.forEach(eqp => {
      total.totalQtd += eqp.qtd
      total.totalUnitPrice += eqp.unitPrice
      total.total += eqp.qtd * eqp.unitPrice
      total.sumWorkHour += eqp.workHour
      total.totalWorkHour += eqp.qtd * eqp.workHour
    })
    return total
  }

  const assetsummary = sumTotalAssets()

  const acceptanceItens = useMemo(() => {
    if (parentServiceOrder && mainServiceOrder) {
      return {
        orderNumber: findReplyByQuestionId(mainServiceOrder.replies, 15506).value,
        item: findReplyByQuestionId(mainServiceOrder.replies, 15507).value
      }
    }
    return
  }, [mainServiceOrder, parentServiceOrder])

  return (
    <View>
      {acceptanceItens && (
        <>
          <Text bold size="h4" align="left">
            Itens de aceite
          </Text>
          <Table width="100%" style={{ border: '' }}>
            <TableRow color={'transparent'}>
              <TableColLabelValue colSpan={2} label={'Item'} value={acceptanceItens.item} style={{ border: '' }} />
            </TableRow>
            <TableRow color={'transparent'}>
              <TableColLabelValue
                colSpan={2}
                label={'Número do pedido'}
                value={acceptanceItens.orderNumber}
                style={{ border: '' }}
              />
            </TableRow>
          </Table>
          <Separator weight={4} />
          <Bar />
        </>
      )}
      <Text bold size="h4" align="left">
        Fatura - Equipamentos
      </Text>
      <Table justify="space-between" width={'100%'}>
        <TableRow>
          <TableHeadText align="center">Cod. Equip.</TableHeadText>
          <TableHeadText align="center">Descrição</TableHeadText>
          <TableHeadText align="center">Qtd</TableHeadText>
          <TableHeadText align="center">Preço Unitário</TableHeadText>
          <TableHeadText align="center">Preço Total</TableHeadText>
        </TableRow>
        {assetsData?.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            <TableColText align="center">{row.codEquip}</TableColText>
            <TableColText align="center">{row.description}</TableColText>
            <TableColText align="center">{row.qtd}</TableColText>
            <TableColText align="center">{toCurrency(row.unitPrice)}</TableColText>
            <TableColText align="center">{toCurrency(row.qtd * row.unitPrice)}</TableColText>
          </TableRow>
        ))}
        <TableRow>
          <TableHeadText align="center" colSpan={3}>
            Total
          </TableHeadText>
          <TableHeadText align="center">{assetsummary.totalQtd}</TableHeadText>
          <TableHeadText align="center">{toCurrency(assetsummary.totalUnitPrice)}</TableHeadText>
          <TableHeadText align="center">{toCurrency(assetsummary.total)}</TableHeadText>
        </TableRow>
      </Table>

      <Separator weight={4} />

      {!isVivo && (
        <>
          <Text bold size="h4" align="left">
            Fatura - Mão de Obra
          </Text>
          <Table justify="space-between" width={'100%'}>
            <TableRow>
              <TableHeadText align="center">Descrição</TableHeadText>
              <TableHeadText align="center">Qtd</TableHeadText>
              <TableHeadText align="center">Preço Unitário</TableHeadText>
              <TableHeadText align="center">Preço Total</TableHeadText>
            </TableRow>
            {assetsData?.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                <TableColText align="center">{row.description}</TableColText>
                <TableColText align="center">{row.qtd}</TableColText>
                <TableColText align="center">{toCurrency(row.workHour)}</TableColText>
                <TableColText align="center">{toCurrency(row.qtd * row.workHour)}</TableColText>
              </TableRow>
            ))}
            <TableRow>
              <TableHeadText align="center">Total</TableHeadText>
              <TableHeadText align="center">{assetsummary.totalQtd}</TableHeadText>
              <TableHeadText align="center">{toCurrency(assetsummary.sumWorkHour)}</TableHeadText>
              <TableHeadText align="center">{toCurrency(assetsummary.totalWorkHour)}</TableHeadText>
            </TableRow>
          </Table>
          <Separator weight={4} />
        </>
      )}

      <>
        <Text bold size="h4" align="right">
          Total: {toCurrency(isVivo ? assetsummary.total : assetsummary.total + assetsummary.totalWorkHour)}
        </Text>
        <Separator weight={4} />
        <Bar />
      </>
    </View>
  )
}

export default Budget
